import { useSelector } from "react-redux";
import { MachineTonnage } from "../interfaces/MachineTonnage";
import { StoreState } from "../interfaces/storeState";

export const useMachineTonnage = (): MachineTonnage =>
  useSelector(getMachineTonnage);

const getMachineTonnage = (state: StoreState): MachineTonnage =>
  state.machineTonnage;
